import React from 'react';
import { useTheme } from 'styled-components';
import { IconButton } from '../../../components/IconButton/IconButton';
import { ReactComponent as DollarIcon } from '../../../assets/images/DollarIcon.svg';

/** The "$" button that opens the Pricing page. A non-empty `disabledReason` disables it and becomes the tooltip. */
export function PricingLaunchButton(props: {
	className: string;
	onClick: () => void;
	disabledReason?: string;
	size?: number;
	style?: React.CSSProperties;
})
{
	const { className, onClick, disabledReason, size, style } = props;
	const theme = useTheme();

	return (
		<IconButton
			className={className}
			tooltip={disabledReason || 'Open Pricing'}
			showDisabledTooltip={true}
			disabled={!!disabledReason}
			placement='bottom'
			onClick={onClick}
			hoverbgcolor={theme.colors.lightestGrey}
			style={{ height: size ?? 32, width: size ?? 32, ...style }}
		>
			<DollarIcon />
		</IconButton>
	);
}
